export default __webpack_public_path__ + "static/kasey_lee-1b427a5e466e64e00e38818b4335d7a6.jpg";